import { render, staticRenderFns } from "./KartuPasien.vue?vue&type=template&id=db302064&"
import script from "./KartuPasien.vue?vue&type=script&lang=js&"
export * from "./KartuPasien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports